import axios, { AxiosError } from 'axios';
import { api } from '../configs/api/api';

// Interfaces
import { INotificationSettings, IUpdateUserData, IUserData } from '../interfaces/user.interfaces';
import { ICounsellorCreate } from '../interfaces/counsellors.interfaces';

export const UserService = {
  profile: async (): Promise<IUserData | any> => {
    try {
      return await api.get('/workers/profile', {});
    } catch (error: any) {
      return error;
    }
  },
  notificationSettings: async (): Promise<{ notification_settings?: INotificationSettings, error?: string }> => {
    try {
      const response = await api.get('/workers/notification-settings', {});
      return response.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateProfile: async (counsellor: IUpdateUserData): Promise<{
    worker_profile?: IUserData,
    message?: string,
    error?: string
  }> => {
    try {
      const response = await api.post('/workers/update-business-profile', counsellor);
      return response.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  makeMeACounsellor: async (counsellorCreate: ICounsellorCreate): Promise<{
    is_counsellor?: boolean,
    is_profile_completed?: boolean,
    message?: string,
    error?: string
  }> => {
    try {
      const response = await api.post('/company/make-me-counsellor', { ...counsellorCreate, is_counsellor: true  });
      return response.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  notificationSettingsUpdate: async (settings: INotificationSettings): Promise<{
    notification_settings?: INotificationSettings,
    error?: string
  }> => {
    try {
      const response = await api.post('/workers/update-notification-settings', {
        ...settings,
        sms_notification: false,
        in_app_notification: true
      });
      return response.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  deleteProfile: async (): Promise<any> => {
    try {
      return await api.delete('/workers/delete-profile');
    } catch (error) {
      return error;
    }
  },
  updatePhoto: async (photo: File): Promise<{ message?: string, photo?: string, error?: string }> => {
    try {
      const response = await api.post('/workers/photo', { photo }, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  deletePhoto: async (): Promise<{ message?: string, error?: string }> => {
    try {
      const response = await api.delete('/workers/photo-delete');
      return response.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  logout: async (): Promise<any> => {
    return await api.post('/company/logout', {});
  },
  fetchSocketToken: async (): Promise<{ data: { socket_token: string }; status: number } | {
    data: any;
    status: number
  }> => {
    return await api.get('/socket/auth').then(result => {
      const { data, status } = result;
      return { data, status };
    }).catch((error: Error | AxiosError) => {
      if (axios.isAxiosError(error) && error.response) {
        const { data, status } = error.response;
        return { data, status };
      } else {
        return {
          data: { error: 'An error has occurred with API processing' },
          status: 401
        };
      }
    });
  }
}
